import { useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Col, Form, Row } from 'antd';

import { ReactComponent as FilterAscIcon } from '../../../../../assets/icons/filter-asc.svg';
import { ReactComponent as FilterDescIcon } from '../../../../../assets/icons/filter-desc.svg';
import { SORTING_ORDERS } from '../../../../../contants/common';
import { setClaimsOverChargeFilters } from '../../../../../redux/Claims/OverCharge/OverChargeActions';
import { routeFileSelector } from '../../../../../utilz/i18n';
import IconButton from '../../../../components/Buttons/IconButton';
import SvgConverter from '../../../../components/Common/SvgConverter';
import HiddenFormInput from '../../../../components/Inputs/HiddenFormInput';
import OverChargeSortingSelector from '../../../../components/Selectors/OverChargeSortingSelector';

const OverChargeClaimsSorting = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { claimsFilters } = useSelector((state) => state.overChargeClaims);
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const handleSortingToggle = (oldType) => {
    if (oldType === SORTING_ORDERS.ASC) {
      return SORTING_ORDERS.DESC;
    }
    if (oldType === SORTING_ORDERS.DESC) {
      return SORTING_ORDERS.ASC;
    }
  };

  const fetchData = useCallback(
    (sortDirectionValue, sortColumnValue) => {
      dispatch(
        setClaimsOverChargeFilters({ pageNo: 1, sortColumn: sortColumnValue, sortDirection: sortDirectionValue }),
      );
    },
    [dispatch],
  );

  const sortDirection = Form.useWatch('sortDirection', form);
  const sortColumn = Form.useWatch('sortColumn', form);

  useEffect(() => {
    if (sortDirection && sortColumn) {
      fetchData(sortDirection, sortColumn);
    }
  }, [sortDirection, sortColumn, fetchData]);

  return (
    <Form
      className="w-100"
      form={form}
      initialValues={{
        sortColumn: claimsFilters.sortColumn,
        sortDirection: claimsFilters.sortDirection,
      }}
    >
      <Row align="middle" gutter={15}>
        <Col sm={15} lg={10}>
          <OverChargeSortingSelector
            className="w-100"
            margin="m-0"
            placeholder={t('translation:default.fields.sortBy.label')}
            name="sortColumn"
            label={''}
          />
        </Col>
        <Col>
          {sortDirection && (
            <IconButton onClick={() => form.setFieldValue('sortDirection', handleSortingToggle(sortDirection))}>
              <SvgConverter
                className="mr-5"
                Icon={sortDirection === SORTING_ORDERS.ASC ? FilterAscIcon : FilterDescIcon}
                height={18}
                width={18}
              />
            </IconButton>
          )}
        </Col>
      </Row>
      <HiddenFormInput name="sortDirection" />
    </Form>
  );
};

export default OverChargeClaimsSorting;
